<template>
  <div>
    <!--<div style="margin-bottom: 10px;">-->
      <!--<SwiperList :swiperList="swiperList"></SwiperList>-->
    <!--</div>-->
    <div class="zbxxd_main_wrapper">
      <div class="container">
        <div class="main">
          <div class="breadcrumb">
            <div class="lable">当前位置:</div>
            <div class="breadcrumb_item">
              <div @click="returnPre(0)">首页</div>
              <div @click="returnPre(1)"><span>></span>{{mtname}}</div>
              <div v-if="model.zbxxClass"><span>></span>{{model.zbxxClass.sys_dname}}</div>
            </div>
          </div>
          <div class="detail">
            <div class="title" v-html="model.sys_title"></div>
            <div style="display: flex;align-items:center;justify-content: center;">
              <div style="text-align: center;margin-right: 4px;">日期: {{model.sys_idate}}</div>
              <div style="text-align: center;">阅读数: {{model.sys_click == 0?1: model.sys_click + 1}}</div>
            </div>
            <div class="split-line"></div>
            <div v-html="model.sys_content" class="content">
            </div>
            <div style="text-align: right;font-size: 16px" v-if="model.sys_author !== null && model.sys_author !== 'CGPT' ">
              <p>广东元正招标采购有限公司</p>
              <p>{{model.sys_idate}}</p>
            </div>
            <div style="display:flex" v-if="model.zbxxfj">
              <div v-if="model.zbxxfj.length>0">附件信息：</div>
              <div v-if="model.zbxxfj.length > 0">
                <div  v-if="+model.zbxxfj[0].zbxxfjtype === 1">
                  <div v-for="i in model.zbxxfj" :key="i.id">
                    <div @click="downFile(i.zbxxfjurl)" style="color:#2f74ff;cursor: pointer;">{{i.zbxxfjname}}</div>
                  </div>
                </div>
                <div v-else>
                  <div v-for="i in model.zbxxfj" :key="i.id">
                    <a :href="i.zbxxfjurl" target=＂_black＂ style="color:#2f74ff;cursor: pointer;">{{i.zbxxfjname}}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import SwiperList from './SwiperList.vue'
  import common from '../../mixin/common'
  // import dayjs from 'dayjs'
  export default {
    mixins: [common],
    data () {
      return {
        model: {},
        swiperList: [],
        mtname: '',
        secname: '',
        mtList: [],
        mtid: ''
      }
    },
    created () {
      document.documentElement.scrollTop = 0
      // this.findSwiperList()
      this.getOperMtId()
      this.getZbxx()
      this.$store.dispatch('updateZbxxClick', {id: this.$route.query.id})
      // document.title = this.model.sys_title
    },
    mounted () {
      // document.title = this.model.sys_title
    },
    methods: {
      getOperMtId () {
        this.$store.dispatch('findOperMtId').then(list => {
          this.mtList = list
          this.mtname = '招标信息'
          if (this.$route.query.mtid) {
            this.mtid = this.$route.query.mtid
          } else {
            let zbxxM = this.mtList.find(v => v.opermtlinkaddr === 'zbxx')
            if (zbxxM) {
              this.mtid = zbxxM.opermtid
            }
          }
          let model = list.find(v => +v.opermtid === +this.mtid)
          if (model) {
            this.mtname = model.opermtname
          }
          if (this.mtid) {
            this.$store.commit('changId', '')
            this.$store.commit('setFirstActiveTab', this.mtid)
            window.localStorage.setItem('firstActiveTab', this.mtid)
          }
        })
      },
      returnPre (val) {
        if (val === 1) {
          this.$router.push({name: 'zbxx', query: {type: this.model.sys_classid, mtid: this.mtid}})
        } else {
          this.$store.commit('changId', '')
          this.$store.commit('setFirstActiveTab', 0)
          window.localStorage.setItem('firstActiveTab', 0)
          this.$router.push({name: 'home'})
        }
      },
      getZbxx () {
        this.$store.dispatch('getZbxxById', {id: this.$route.query.id}).then(data => {
          if (data) {
            this.model = data
            document.title = this.model.sys_title
          }
        })
      },
      backList () {

      },
      findSwiperList () {
        this.$store.dispatch('findSwiperList', {operadmtid: this.$route.query.mtid}).then(data => {
          if (data) {
            this.swiperList = data.appends
          }
        })
      }
    },
    components: {SwiperList},
    watch: {
      $route () {
        this.$store.dispatch('updateZbxxClick', {id: this.$route.query.id})
      }
    },
    computed: mapState({
      secondActiveTab: state => state.secondActiveTab,
      firstActiveTab: state => state.firstActiveTab,
      mtid: state => state.id,
      picAddr: state => state.picAddr
    })
  }
</script>

<style lang="stylus" scoped>
  .zbxxd_main_wrapper {
    background-color: #FAFAFA;
    display flex
    justify-content center
    /*padding: 0px 10px 20px 10px*/
    .container {
      width 1246px
      margin 50px 0
      .main {
        .breadcrumb {
          display: flex;
          align-items: center;
          border-bottom: 1px solid #FAFAFA;
          .lable {
            padding-right: 10px;
            color: #999999;
          }
          .breadcrumb_item {
            display: flex;
            justify-items: center;
            cursor: pointer;
            :last-child {
              color: #999999;
              cursor: text;
            }
            span {
              margin: 0 5px;
            }
            .breadcrumb_item_title {
              width: 380px;
              list-style: none;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
              overflow: hidden;
            }
          }
        }
        .detail {
          background-color: #fff;
          margin 10px 0
          padding 30px
          .title {
            font-size: 22px;
            text-align: center;
            font-weight: 900;
            padding-bottom 20px
          }
          .content {
            padding-top 20px
            line-height: 28px;
            max-width: 100% !important;
          }
        }
      }
    }
  }

  .split-line {
    width: 100%;
    margin: 11px 0 15px;
    border-bottom: 1px solid #d1dbe5;
  }
</style>



// WEBPACK FOOTER //
// ZbxxDetail.vue?3ab1947a